import React, { useState, useEffect } from "react";
import _ from "lodash";
import PurchaseOrderHistory from "./PurchaseOrderHistory";
import PurchaseOrders from "./PurchaseOrders";
import PurchaseOrderList from "./PurchaseOrderList";

// bootrap
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useLazyQuery } from "@apollo/client";
import { GET_PURCHASE_ORDER_DETAIL } from "../../apollo/purchaseOrderDetail/query";
import { USER_KEY } from "../../const";
import BreadCrumbComponent from "../../components/BreadCrumbComponent";
import SalepageOrderList from "./SalepageOrderList";
// import StockOptions from "./stockOptions/StockOptions";


export default function PurchaseOrder() {
  const [activeKey, setActiveKey] = useState(
    localStorage.getItem("activeKey") || "purchaseOrder" //"stockOption"
  );
  const [purchaseOrderDetail, setPurchaseOrderdetail] = useState();
  const [purchaseOrderDetailTotal, setPurchaseOrderdetailTotal] = useState();
 

  // stateForPurchaseOrderHistoryPage
  const [purchaseOrderDetailHistory, setPurchaseOrderdetailHistory] =
    useState();
  const [purchaseOrderDetailTotalHistory, setPurchaseOrderdetailTotalHistory] =
    useState();

  // UseQueryLazy

  const [getPurchaseOrderDetail, { data: purchaseOrderdetailData, loading }] =
    useLazyQuery(GET_PURCHASE_ORDER_DETAIL, {
      fetchPolicy: "cache-and-network",
    });

  //
  const [
    getPurchaseOrderDetailHistory,
    {
      data: purchaseOrderdetailDataHistory,
      loading: loadingPurchaseOrderHistory,
    },
  ] = useLazyQuery(GET_PURCHASE_ORDER_DETAIL, {
    fetchPolicy: "cache-and-network",
  });

  const handleTabSelect = (key) => {
    setActiveKey(key);
  };

  // console.log("activekey================================>", activeKey);
  // useEeffect

  useEffect(() => {
    localStorage.setItem("activeKey", activeKey);
  }, [activeKey]);

  useEffect(() => {
    if (purchaseOrderdetailData?.purchaseorderdetails) {
      // setPurchaseOrderdetail(
      //   purchaseOrderdetailData?.purchaseorderdetails?.data
      // );
      setPurchaseOrderdetailTotal(
        purchaseOrderdetailData?.purchaseorderdetails?.total
      );
    }
  }, [JSON.stringify(purchaseOrderdetailData?.purchaseorderdetails)]);

  useEffect(() => {
    if (purchaseOrderdetailDataHistory?.purchaseorderdetails) {
      setPurchaseOrderdetailHistory(
        purchaseOrderdetailDataHistory?.purchaseorderdetails?.data
      );
      setPurchaseOrderdetailTotalHistory(
        purchaseOrderdetailDataHistory?.purchaseorderdetails?.total
      );
    }
  }, [JSON.stringify(purchaseOrderdetailDataHistory?.purchaseorderdetails)]);

  useEffect(() => {
    // _purchaseOrderDetail();
    _purchaseOrderDetailHistory();
  }, []);

  const _purchaseOrderDetail = async () => {
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop
      ?.id;
    await getPurchaseOrderDetail({
      variables: {
        orderBy: "createdAt_DESC",
        where: {
          status: "PENDING",
          isSale: false,
          shop: shopId,
        },
      },
    });
  };

  const _purchaseOrderDetailHistory = async () => {
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop
      ?.id;
    await getPurchaseOrderDetailHistory({
      variables: {
        orderBy: "createdAt_DESC",
        where: {
          shop: shopId,
        },
      },
    });
  };

  //   console.log("first", purchaseOrderDetail);

  return (
    <React.Fragment>
      <div className="purchaseorder-main">
        <div className="purchaseorder-header">
          <BreadCrumbComponent
            // goback={() => history.goBack()}
            txtFirst="ຂໍ້ມູນການສັ່ງຊື້"
            // txtSecond={`ສາງສິນຄ້າ ${productTotal ?? 0} ລາຍການ`}
          /> 
        </div>
        <div className="p-4"> 
           <Tabs
            defaultActiveKey="home"
            id="uncontrolled-tab-example"
            activeKey={activeKey}
            onSelect={handleTabSelect}
            className="mb-3">
            <Tab eventKey="home" title="ສິນຄ້າທັງໝົດ" defaultChecked={true} >
              <PurchaseOrders
                setPurchaseOrderdetailTotal={setPurchaseOrderdetailTotal}
                _purchaseOrderDetail={_purchaseOrderDetail}
                purchaseOrderdetailData={purchaseOrderdetailData}
              />
            </Tab>
            <Tab eventKey="listOrder" title="ລາຍການສັ່ງຊື້" >
              <PurchaseOrderList
                // loading={loading}
                // empty={purchaseOrderdetailData}
                // purchaseOrderDetail={purchaseOrderDetail}
                tab={activeKey}
              />
            </Tab>
            <Tab eventKey="contact" title="ປະຫວັດການສັ່ງຊື້">
              <PurchaseOrderHistory
                purchaseOrderDetailHistory={purchaseOrderDetailHistory}
                purchaseOrderDetailTotalHistory={
                  purchaseOrderDetailTotalHistory
                }
              />
            </Tab>
            <Tab eventKey="salepage_order" title="ອໍເດີຂອງ SalePage">
              <SalepageOrderList
              
              />
            </Tab>
          
          </Tabs>
        </div>
      </div>
    </React.Fragment>
  );
}
